// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperPreviewList-cls1_dm5","cls2":"PaperPreviewList-cls2_qXS PaperPreviewList-cls1_dm5"};